<footer class="bg-main-blue text-xs text-white py-2.5 px-5">
  <p class="opacity-80">© 2024 VISA Myanmar. All rights reserved.</p>
</footer>
